import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import Context from './Context';
const Consumer = ({ children }) => (_jsx(Context.Consumer, { children: (props) => React.cloneElement(children, { props }) }));
export default memo(Consumer);
